import { css } from "@emotion/react"
import styled from "@emotion/styled"
import { useMediaQuery } from "@mui/material"
import type { FC, PropsWithChildren } from "react"

// MUI v7: Hidden component removed, use useMediaQuery instead
const Mobile: FC<PropsWithChildren> = ({ children }) => {
  const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.up("md"))
  return isDesktop ? null : <>{children}</>
}

const Desktop: FC<PropsWithChildren> = ({ children }) => {
  const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.up("md"))
  return isDesktop ? <>{children}</> : null
}

const Shared = {
  Mobile,
  Desktop,
}

export default Shared

export const transitionTime = 800
export const menuTransitionTime = 400
// Smooth bounce easing - subtle overshoot with gentle return
export const finalBounceEase = "cubic-bezier(0.25, 1, 0.5, 1.1)"

export const transition = css`
  transition: all ${transitionTime}ms ${finalBounceEase};
`

export const bouncingWrapper = styled.div`
  position: absolute;
`
type OffscreenProps = {
  xPos?: string | number
  yPos?: string | number
  important?: boolean
}
export const offScreen = ({
  xPos = 0,
  yPos = 0,
  important = false,
}: OffscreenProps) => css`
  transform: translate3d(${xPos}, ${yPos}, 0) ${important && "!important"};
  opacity: 0 ${important && "!important"};
  visibility: hidden ${important && "!important"};
`
export const SectionContainer = styled.div<{
  active: boolean
  openMenu: boolean
}>`
  position: absolute;
  display: flex;
  overflow: hidden;
  width: 100%;
  height: 100%;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 35px;
  padding-bottom: 70px;
  text-align: center;
  z-index: ${(p) => (p.active ? 10 : 2)};
  pointer-events: ${(p) => (p.active ? "auto" : "none")};
  > * {
    ${transition}
    ${(p) =>
      p.active &&
      `
        transform: translate3d(0,0,0) !important;
        visibility:visible !important;
        opacity:1 !important;
    `}
    ${(p) =>
      p.openMenu && offScreen({ yPos: "calc(100% + 20vh)", important: true })}
  }
`
